<template>
  <div class="project container">
    <h2>重点人群管理系统软件开发项目</h2>
    <h4>一．项目编号：</h4>
    <h4>二．项目名称：盐城市亭湖区卫生健康委员会重点人群管理系统软件开发项目</h4>
    <h4>三．中标信息</h4>
    <p>供应商名称：中国移动通信集团江苏有限公司</p>
    <p>供应商地址：江苏省南京市虎踞路59号</p>
    <p>中标（成交）金额：998000元</p>
    <h4>四．主要标的信息</h4>
    <div class="type">
      <h2>软件类</h2>
      <h3>
        <span>名&emsp;&emsp;称：</span>盐城市亭湖区卫生健康委员会重点人群管理系统软件开发项目
      </h3>
      <h3>
        <span>品&emsp;&emsp;牌：</span> 详见投标文件报价清单。
      </h3>
      <h3>
        <span>规格型号：</span> 详见投标文件报价清单。
      </h3>
      <h3>
        <span>数&emsp;&emsp;量：</span> 详见投标文件报价清单。
      </h3>
      <h3>
        <span>单&emsp;&emsp;价：</span> 详见投标文件报价清单。
      </h3>
    </div>
    <p>
      <b>评审专家名单：朱衍涛、陈军、赵旭东、曾玉庆、金飞</b>
    </p>
    <p>
      <b>代理服务收费标准及金额：</b>
    </p>
    <p>本次招标代理服务费按苏价服【2011】137号文（货物类）收费标准计取，由成交人承</p>
    <p>担，供应商在报价时包含在投标报价中报价。（本条不单独列表报价，自行综合考虑在</p>
    <p>投标报价中，中标后采购人不再另行支付）。</p>
    <p>收费金额：7500元</p>
    <h4>五、公告期限</h4>
    <p>2022年5月8日-2022年5月9日</p>
    <h4>六、其他补充事宜</h4>
    <p>无</p>
    <h4>七、凡对本次公告内容提出询问，请按以下方式联系。</h4>
    <div class="info">
      <p>1.采购人信息</p>
      <h3>
        <span>名&emsp;&emsp;称：</span>
        <b>盐城市亭湖区卫生健康委员会</b>
      </h3>
      <h3>
        <span>地&emsp;&emsp;址：</span>
        <b>盐城市建军东路131号</b>
      </h3>
      <h3>
        <span>联系方式：</span>
        <b>15396881555</b>
      </h3>
    </div>
    <div class="info">
      <p>2.采购代理机构信息</p>
      <h3>
        <span>名&emsp;&emsp;称：</span>
        <b>盐城市建业工程咨询有限公司</b>
      </h3>
      <h3>
        <span>地&emsp;&emsp;址：</span>
        <b>盐城市亭湖区范公中路89号嘉元广场东区北栋17层</b>
      </h3>
      <h3>
        <span>联系方式：</span>
        <b>13921816170</b>
      </h3>
    </div>
    <div class="info">
      <p>3.项目联系方式</p>
      <h3>
        <span>项目联系人:</span>
        <b>朱先生</b>
      </h3>
      <h3>
        <span>电&emsp;&emsp;&emsp;话:</span>
        <b>15396881555</b>
      </h3>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Legal',
};
</script>
<style scoped>
.project {
  margin-bottom: 100px;
}
.project > h2 {
  margin-top: 100px;
  margin-bottom: 20px;
  text-align: center;
  font-size: 32px;
  color: #333;
  font-weight: bold;
}
.project > h4 {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.7;
  color: #333;
}
.project > p {
  margin-bottom: 20px;
  text-indent: 2em;
  font-size: 16px;
  color: #333;
}
.type {
  margin-left: 2em;
  margin-bottom: 20px;
  width: 700px;
  height: 400px;
  border: 1px solid #ddd;
}
.type h2 {
  width: 100%;
  text-align: center;
  padding: 20px 0;
  font-size: 24px;
  color: #333;
  border-bottom: 1px solid #ddd;
}
.type h3 {
  padding: 15px 20px;
  font-size: 16px;
  color: #333;
  font-weight: normal;
}
.project span {
  display: inline-block;
  width: 100px;
}
.info {
  margin-left: 2em;
}
.info p {
  font-size: 16px;
  color: #333;
  margin-bottom: 20px;
}
.info h3 {
  margin-left: 2em;
  margin-bottom: 15px;
  font-weight: normal;
  font-size: 14px;
  color: #666;
}
.info h3 b {
  color: #333;
}
</style>
